import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { EditarInventario } from '@/features/inventario/page/editar/EditarInventario';
import { NovoInventario } from '@/features/inventario/page/novo/NovoInventario';

const RouteInventarioParamsSchema = z.discriminatedUnion('action', [
    z.object({
        action: z.literal('cadastrar'),
        idpk: z.undefined().optional(),
    }),
    z.object({
        action: z.literal('editar'),
        idpk: z.string(),
    }),
]);

export const Route = createFileRoute('/a/inventario/$action/{-$idpk}')({
    component: Component,
    params: {
        parse: (params) => {
            const result = RouteInventarioParamsSchema.safeParse(params);

            return result.success ? result.data : false;
        },
    },
});

function Component() {
    const params = Route.useParams();

    if (params.action === 'cadastrar') {
        return <NovoInventario />;
    }

    return <EditarInventario idpk={params.idpk} />;
}
